var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-form" },
    [
      _c(
        "v-card",
        { staticClass: "popups-default" },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v(_vm._s(_vm.$t("front.sign_in.login.titles.modal_title")))
            ])
          ]),
          _c(
            "v-card-text",
            { staticClass: "loading-wrapper" },
            [
              _vm.loading
                ? _c("span", {
                    staticClass: "preloader",
                    style: {
                      backgroundImage:
                        "url('" + _vm.preloaderBackgroundImage + "')"
                    }
                  })
                : _vm._e(),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("front.sign_in.login.titles.title")))
              ]),
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "email",
                          rules: _vm.usernameRules,
                          label: _vm.$t("front.sign_in.login.form.username"),
                          required: "",
                          autocomplete: "off"
                        },
                        on: {
                          change: function($event) {
                            _vm.errorMessage = null
                          }
                        },
                        model: {
                          value: _vm.username,
                          callback: function($$v) {
                            _vm.username = $$v
                          },
                          expression: "username"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "password",
                          rules: _vm.passwordRules,
                          label: _vm.$t("front.sign_in.login.form.password"),
                          required: "",
                          autocomplete: "off"
                        },
                        on: {
                          change: function($event) {
                            _vm.errorMessage = null
                          }
                        },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.twoFactorAuth
                    ? _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: _vm.mfaCodeRules,
                              label: _vm.mfaCodeLabel,
                              required: "",
                              autocomplete: "off"
                            },
                            on: {
                              change: function($event) {
                                _vm.errorMessage = null
                              }
                            },
                            model: {
                              value: _vm.mfaCode,
                              callback: function($$v) {
                                _vm.mfaCode = $$v
                              },
                              expression: "mfaCode"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.twoFactorAuth
                    ? _c(
                        "div",
                        { staticClass: "form-group two-factor-auth" },
                        [
                          _vm.canResendCodeAfterSeconds
                            ? _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "front.sign_in.login.form.can_resend_mfa_code_after",
                                      {
                                        minutes: _vm.waitUntilCanResetMinutes,
                                        seconds: _vm.waitUntilCanResetSeconds
                                      }
                                    )
                                  )
                                }
                              })
                            : _vm._e(),
                          _c("v-btn", {
                            attrs: {
                              density: "compact",
                              variant: "plain",
                              disabled: !!_vm.canResendCodeAfterSeconds
                            },
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "front.sign_in.login.form.resend_mfa_code"
                                )
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.submitForm(true)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: !_vm.valid },
                      on: {
                        click: function($event) {
                          return _vm.submitForm(false)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("front.sign_in.login.button.login")) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              ),
              _c("v-card-actions", [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.forgot }
                  },
                  [_vm._v(_vm._s(_vm.$t("front.sign_in.login.button.forgot")))]
                ),
                _vm.signupEnabled
                  ? _c(
                      "a",
                      {
                        attrs: { href: "javascript:void(0)" },
                        on: { click: _vm.register }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("front.sign_in.login.button.create"))
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }